import { render, staticRenderFns } from "./heng.vue?vue&type=template&id=5df7aa64&scoped=true&"
import script from "./heng.vue?vue&type=script&lang=js&"
export * from "./heng.vue?vue&type=script&lang=js&"
import style0 from "./heng.vue?vue&type=style&index=0&id=5df7aa64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7aa64",
  null
  
)

export default component.exports